import * as config from 'config';
import { apiFetch, getAuthorizationHeaders } from 'utils/fetch';
import { SubscriptionsResponse } from 'models/husqiotbus';

export async function getSubscriptions(
): Promise<SubscriptionsResponse> {
  const headers = getAuthorizationHeaders();
  const url = `${config.backendApi}/husqiotbus/subscriptions`;

  return apiFetch<any>(url, { headers });
}
